import { FormattedMessage } from 'react-intl'

import { Heading } from 'Components/_theme'
import { LanguageDropdown } from 'Components/LanguageDropdown/LanguageDropdown'

export const OfferAcceptedContent = () => (
  <>
    <Heading className="PurchaseContent-heading" size={1}>
      <FormattedMessage id="OfferAcceptedContent_heading" />
    </Heading>

    <div className="PurchaseContent-content">
      <p>
        <FormattedMessage id="OfferAcceptedContent_content" />
      </p>
    </div>

    <LanguageDropdown isLandingPage />
  </>
)
